import React, { useEffect } from "react";
import classes from "./ScrollProgress.module.css";

import ContainerClasses from "../../classes/ContainerClasses";

import { useSelector, useDispatch } from "react-redux";
import { ScrollActions } from "../../../store/Slices/ScrollSlice";
import SectionScroll from "./SectionScroll/SectionScroll";

const ScrollProgress = (props) => {
  const dispatch = useDispatch();

  const LandingScroll = useSelector((state) => state.scroll.LandingHeight);
  const DepartmentsScroll = useSelector(
    (state) => state.scroll.DepartmentsHeight
  );
  const ourWorkScroll = useSelector((state) => state.scroll.OurWorkHeight);
  const MapScroll = useSelector((state) => state.scroll.MapHeight);
  const FactsScroll = useSelector((state) => state.scroll.FactsHeight);
  const FooterScroll = useSelector((state) => state.scroll.FooterHeight);

  const opacityScroll = useSelector((state) => state.scroll.opacity);
  const XScroll = useSelector((state) => state.scroll.x);

  // console.log("F&F Scroll: ",FactsScroll);

  return (
    <div
      className={classes.container}
      style={{ opacity: opacityScroll, transform: `translateX(${XScroll}px)` }}
    >
      <SectionScroll
        title="Top"
        height={LandingScroll * 100}
        size={60}
        container={ContainerClasses.LandingContainer}
        top={1}
      />
      <SectionScroll
        title="Departments"
        height={DepartmentsScroll * 100}
        size={25}
        container={ContainerClasses.DepartmentsContainer}
      />
      <SectionScroll
        title="Our Work"
        height={ourWorkScroll * 100}
        size={150}
        container={ContainerClasses.OurWorkContainer}
      />
      <SectionScroll
        title="Our Centers"
        height={MapScroll * 100}
        size={75}
        container={ContainerClasses.MapContainer}
      />
      <SectionScroll
        title="Facts & Figures"
        height={FactsScroll * 100}
        size={200}
        container={ContainerClasses.FactsNFIguresContainer}
      />
      <SectionScroll
        title="Connect"
        height={FooterScroll * 100 * 1.01}
        size={75}
        container={ContainerClasses.FooterContainer}
      />
    </div>
  );
};
export default ScrollProgress;
